import { ActionTopic } from './action-topic.enum';
import { Dictionary } from '../../models/dictionary.model';

export class MessageModel {

    /**
     * The topic of the message
     */
    public topic: ActionTopic;

    /**
     * Collection of values to be included with the message.  The receiver will parse this values out.
     */
    public values: Dictionary;

    /**
     * Initializes a new instance of the MessageModel
     */
    constructor() {
        this.values = new Dictionary([]);
    }

}
